module.exports = __webpack_public_path__ + "img/avatar2.1c3cfd0f.png";